import React, { FC, useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { logEvent } from 'services/amplitude';
import Popover from '@material-ui/core/Popover';
import moment from 'moment';
import Avatar from '@material-ui/core/Avatar';
import { getAllAnetaPacks as getAllAnetaPacksAction } from 'actions/aneta-pack';
import _ from 'lodash';
import { connect } from 'react-redux';
import { IAnetaPacks } from 'types';
import { IRootState } from 'store';
import Modal from 'components/common/modal/modal';
import AnetapackMerge from 'components/common/anetapackModals/anetapackMerge';
import AnetapackOptions from 'components/common/anetapackModals/applyAnetapackOptions';
import AnetapackContent from 'components/common/anetapackModals/anetapackContent';
import buttons from 'style/buttons.module.scss';
import ArrowIcon from '../calendar/arrowIcon';
import styles from './index.module.scss';
import AnetaPackLibrary from '../AnetaPackLibrary/index';

const mstp = (state: IRootState) => state.anetaPack;
interface Props {
  anetaPacks?: IAnetaPacks[];
  getAllAnetaPacks?: () => void;
  searcIndex: (
    inputArray: moment.Moment[][],
    searchValue: string
  ) => number[] | null;
}

const ShareAnetaPack: FC<Props> = ({
  searcIndex,
  anetaPacks,
  getAllAnetaPacks,
}) => {
  const [selectedAnetaPack, setSelectedAnetaPack] = useState<number>();
  const [isOpenContent, setIsOpenContent] = useState(false);
  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [isOpenMerge, setIsOpenMerge] = useState(false);
  const [isOpenLibrary, setIsOpenLibrary] = useState(false);
  const [anetaPackName, setAnetaPackName] = useState('Choose Anetapack');
  const [selectedDate, setSelectedDate] = useState(moment().toDate());

  const handleOpenMerge = (date?: Date) => {
    setIsOpenMerge(!isOpenMerge);
    if (date) {
      setSelectedDate(date);
    }
  };
  const handleOpenContent = () => {
    setIsOpenContent(!isOpenContent);
  };
  const handleOpenOptions = () => {
    setIsOpenOptions(!isOpenOptions);
  };
  const handleOpenLibrary = () => {
    setIsOpenLibrary(!isOpenLibrary);
  };

  useEffect(() => {
    if (getAllAnetaPacks) {
      getAllAnetaPacks();
    }
  }, [getAllAnetaPacks]);

  const handleChooseAnetapack = (value: IAnetaPacks) => {
    setSelectedAnetaPack(value.id);
    setAnetaPackName(value.name);
  };

  const [visible, setVisible] = useState(false);
  const useStyles = makeStyles(() => {
    return createStyles({
      formControl: {
        margin: '0px',
        minWidth: 120,
        width: '100%',
        border: '1px solid #E8E7EC',
        borderRadius: 100,
      },
    });
  });

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    logEvent('ChooseAnetapack');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = open ? 'simple-popover' : undefined;
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpenLibrary}
        withoutBackground
        modalOpen={handleOpenLibrary}
        modalContent={
          <AnetaPackLibrary
            openNext={handleOpenContent}
            anetaPacks={anetaPacks || []}
            handleClose={handleOpenLibrary}
            handleChooseAnetapack={handleChooseAnetapack}
          />
        }
      />
      <Modal
        isOpen={isOpenOptions}
        modalOpen={handleOpenOptions}
        modalContent={
          <AnetapackOptions
            openNext={handleOpenMerge}
            handleClose={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
          />
        }
      />
      <Modal
        isOpen={isOpenMerge}
        modalOpen={handleOpenMerge}
        withoutBackground
        modalContent={
          <AnetapackMerge
            handleClose={handleOpenMerge}
            searcIndex={searcIndex}
            openPrev={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
            date={selectedDate}
          />
        }
      />
      <div className={styles.description}>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => null}
          className={styles.inform}
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
        >
          !
        </div>{' '}
        <span>Apply an Anetapack</span>
        {visible && (
          <div className={styles.informToolTip}>
            An Anetapack contains a schedule of activities and digital
            resources. Setup is easy when you start with an Anetapack
          </div>
        )}
      </div>

      <FormControl className={`${classes.formControl} ${styles.formInput}`}>
        <div
          role="button"
          onKeyDown={() => null}
          tabIndex={0}
          onClick={handleClick}
          className={`${styles.customSelect} ${
            anchorEl !== null && styles.arrowRotate
          }`}
        >
          <span>{anetaPackName}</span>
          <ArrowIcon />
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div className={styles.modal}>
            <div className={styles.modalHeader}>
              <p>Anetapack Library </p>
              <span
                onClick={handleOpenLibrary}
                role="button"
                onKeyDown={() => null}
                tabIndex={0}
              >
                See All
              </span>
            </div>
            {anetaPacks &&
              !_.isEmpty(anetaPacks) &&
              anetaPacks.map((pack: IAnetaPacks) => (
                <div
                  onClick={() => {
                    handleChooseAnetapack(pack);
                    handleClose();
                  }}
                  className={styles.packListItem}
                  role="button"
                  onKeyDown={() => null}
                  tabIndex={0}
                  key={pack.id}
                >
                  <Avatar src={pack.avatar} alt={pack.name} />
                  <span>{`${pack.name}, ${pack.grades[0]} grade`}</span>
                </div>
              ))}
          </div>
        </Popover>
      </FormControl>
      <Modal
        isOpen={isOpenContent}
        modalOpen={handleOpenContent}
        withoutBackground
        trigger={
          <button
            type="submit"
            className={`${buttons.buttonBlue} ${styles.button}`}
            onClick={() => logEvent('ApplyAnetapackButton')}
            disabled={!selectedAnetaPack}
          >
            Explore and Apply
          </button>
        }
        modalContent={
          <AnetapackContent
            handleClose={handleOpenContent}
            openNext={handleOpenOptions}
            selectedAnetaPackId={selectedAnetaPack || 0}
          />
        }
      />
    </div>
  );
};

export default connect(mstp, { getAllAnetaPacks: getAllAnetaPacksAction })(
  ShareAnetaPack
);
